export function convertPenceToPounds(pence: number | undefined): string {
  if (pence === undefined) return '0.00'
  return (pence / 100).toFixed(2)
}

export function convertPoundsToPence(pounds: number): number {
  return Math.round(pounds * 100)
}

export function calculatePriceWithVAT(price: number, vatRate: number): number {
  return price + (price * vatRate / 100)
}

export function calculatePriceWithoutVAT(price: number, vatRate: number): number {
  return price / (1 + vatRate / 100)
}

export function calculateVATAmount(price: number, vatRate: number): number {
  return price * vatRate / 100
}
